var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClarityErrorLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm0 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.066 15.458c-.265 0-.52-.16-.707-.443-.187-.283-.293-.668-.293-1.069V6.97c0-.401.106-.786.293-1.07.188-.283.442-.442.707-.442.266 0 .52.16.707.443.188.283.293.668.293 1.069v6.976c0 .401-.105.786-.293 1.07-.187.283-.441.442-.707.442zM12.066 18.458a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "#EAEAEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityErrorLine);
export default __webpack_public_path__ + "static/media/clarityErrorLine.1029b9acb86709bb54450f7ce4a61c0f.svg";
export { ForwardRef as ReactComponent };